import { assertIsError } from '../../utils/assert-is-error';
import { cxmRulesClient } from './client';
import { toV2EntityType } from './utils/entity-type-converter';
import { cxmLoggerInstance } from './utils/logger';
export const getCxmExperience = async (requestContext) => {
    try {
        return await cxmRulesClient.instance.getExperiences({
            context: {
                application: {
                    salesChannelId: requestContext.salesChannelId,
                    filmTerritoryShortCode: requestContext.filmTerritoryShortCode
                },
                customer: {
                    loyaltyMemberIdHash: requestContext.memberIdHash
                },
                journey: {
                    viewedEntities: {
                        current: [
                            {
                                entityType: toV2EntityType(requestContext.entityType),
                                componentId: requestContext.componentId
                            }
                        ]
                    }
                }
            }
        });
    }
    catch (error) {
        assertIsError(error);
        // TODO: Dispatch experience load failure to CXM Tracking API. #286494
        cxmLoggerInstance.error(error.message);
        throw error;
    }
};
